<template>
  <div class="bg-smoke-100 text-dark">
    <div class="main-container">
      <div class="flex flex-wrap justify-between pt-20 pb-12 lg:pt-12 lg:pb-20 xl:pt-32">
        <div class="w-full md:w-1/2 lg:w-1/3 pb-12 md:pb-0">
          <a :href="baseURL"><AppLogo /></a>
          <p class="pt-6 opacity-75">
            Connecting buyers and manufacturers using the world’s best sourcing experts & technology built by buyers, for buyers.
          </p>
          <div class="pt-9">
            <h3 class="text-xl">Sign Up to Our Newsletter</h3>
            <div class="flex pt-2">
              <div id="hubspotForm" ></div>
            </div>
          </div>
          <div class="flex pt-8 items-center">
            <h3 class="text-xl">Follow Us:</h3>
            <div class="flex pl-6">
              <a
                target="_blank"
                :href="buyhiveLinkedinLink"
                class="block rounded-full p-3 bg-dark bg-opacity-10"
              >
                <img src="@/assets/icons/linkedin.svg">
              </a>
              <a
                target="_blank"
                :href="buyhiveFacebookLink"
                class="block rounded-full p-3 bg-dark bg-opacity-10 ml-2"
              >
                <img src="@/assets/icons/facebook.svg">
              </a>
            </div>
          </div>
        </div>
        <div class="relative w-1/2 lg:w-content">
          <h3 class="text-xl">About Us</h3>
          <div class="pt-3 md:pt-4 text-17px opacity-75">
            <LinksList :links="aboutLinks" />
          </div>
          <div class="absolute pt-6 hidden lg:block">
            <h3 class="text-xl">We accept</h3>
            <div class="flex items-center relative w-content">
              <img src="@/assets/images/visaCard.png">
              <img src="@/assets/images/masterCard.png">
              <img src="@/assets/images/expressCard.png" class="ml-1">
              <img src="@/assets/images/achBg.png" class="ml-2">
              <img
                src="@/assets/images/ach.png"
                class="absolute right-0 px-5"
                width="65"
              >
            </div>
          </div>
        </div>
        <div class="w-1/2 lg:w-content md:pt-8 lg:pt-0">
          <h3 class="text-xl">Our Services</h3>
          <div class="pt-3 md:pt-4 text-17px opacity-75">
            <LinksList :links="servicesLinks" />
          </div>
        </div>
        <div class="w-1/2 lg:w-content pt-8 lg:pt-0">
          <h3 class="text-xl">Account</h3>
          <div class="pt-3 md:pt-4 text-17px opacity-75">
            <LinksList :links="linksForAccountList" />
          </div>
        </div>
        <div class="w-1/2 lg:w-content pt-8 lg:pt-0">
          <h3 class="text-xl">Our Locations</h3>
          <div class="pt-3 md:pt-4 text-17px opacity-75">
            <p class="py-1 font-medium">BuyHive Limited</p>
            <p class="py-1">
              Dragon Industrial Bldg.<br>
              Unit 8B, 93 King Lam St.<br>
              Cheung Sha Wan,<br>
              Kowloon, Hong Kong
            </p>
            <p class="pt-6 pb-1 font-medium">BuyHive USA Inc.</p>
            <p class="py-1">
              4730 South Fort Apache Rd.<br>
              Suite 300<br>
              Las Vegas, NV 89147<br>
              USA
            </p>
          </div>
        </div>
        <div class="w-1/2 pt-4 md:pt-8 lg:hidden">
          <h3 class="text-xl">We accept</h3>
          <div class="flex items-center relative w-content">
            <img src="@/assets/images/visaCard.png">
            <img src="@/assets/images/masterCard.png">
            <img src="@/assets/images/expressCard.png" class="ml-1">
            <img src="@/assets/images/achBg.png" class="ml-2">
            <img
              src="@/assets/images/ach.png"
              class="absolute right-0 px-5"
              width="65"
            >
          </div>
        </div>
      </div>
      <div class="pt-8 pb-10 border-t border-white md:border-dark flex justify-between md:opacity-50 flex-wrap-reverse">
        <span class="mb-2 md:mb-0">
          © {{ date.getFullYear() }} BuyHive Limited All Rights Reserved
        </span>
        <ul class="md:flex mb-8 md:mb-0">
          <li class="md:pr-6">
            <a :href="buyhiveTermOfUse">
              Terms of Use
            </a>
          </li>
          <li class="md:px-6">
            <a :href="buyhivePrivayPolicy">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import AppLogo from './AppLogo'
import { mapGetters } from 'vuex'
import LinksList from './LinksList'
export default {
  name: 'Footer',
  components: {
    AppLogo,
    LinksList
  },
  data() {
    return {
      buyhiveFacebookLink: process.env.VUE_APP_BUYHIVE_FACEBOOK,
      buyhiveLinkedinLink: process.env.VUE_APP_BUYHIVE_LINKEDIN,
      buyhiveTermOfUse: process.env.VUE_APP_BUYER_TERMS,
      buyhivePrivayPolicy: process.env.VUE_APP_PRIVACY_POLICY,
      buyhiveIpPolicy: process.env.VUE_APP_IP_POLICY,
      buyhiveCookiePolicy: process.env.VUE_APP_COOKIE_POLICY,
      date: new Date(),
      aboutLinks: [
        {
          title: 'Our Story',
          href: process.env.VUE_APP_BUYHIVE_STORY
        },
        {
          title: 'How to Buy',
          href: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY
        },
        {
          title: 'Our Partners',
          href: process.env.VUE_APP_BUYHIVE_PARTNERS
        },
        {
          title: 'Contact Us',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/contact-us`
        },
        {
          title: 'Careers',
          href: process.env.VUE_APP_BUYHIVE_CAREERS
        },
        {
          title: 'Terms of Use',
          href: process.env.VUE_APP_BUYER_TERMS
        },
        {
          title: 'Privacy Policy',
          href: process.env.VUE_APP_PRIVACY_POLICY
        }
      ],
      servicesLinks: [
        {
          title: 'Expert Sourcing',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}`
        },
        {
          title: 'Contract Manufacturing',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}/contract-manufacturing/`
        },
        {
          title: 'Buy',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/`
        },
        {
          title: 'Financing',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}/finance-page/`
        }
      ],
      accountLinks: [
        {
          title: 'Sign In',
          to:  '/u/sign-in'
        },
        {
          title: 'Register to Buy',
          href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/register`
        },
        { title: 'My Profile', href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/profile` },
        { title: 'My Orders', href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/profile/my-orders` },
        { title: 'Register to Sell', href: process.env.VUE_APP_REGISTER_AS_SUPPLIER },
        { title: 'Become a Sourcing Expert', href: `${process.env.VUE_APP_SERVER_BASE_URL}/become-a-sourcingexpert` }
      ],
      buyerLoggedAccountLinks: [
        { title: 'My Profile', href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/profile` },
        { title: 'My Orders', href: `${process.env.VUE_APP_SERVER_BASE_URL}/buy/profile/my-orders` },
        { title: 'Register to Sell', href: process.env.VUE_APP_REGISTER_AS_SUPPLIER },
        { title: 'Become a Sourcing Expert', href: `${process.env.VUE_APP_SERVER_BASE_URL}/become-a-sourcingexpert` }
      ],
      freelancerLoggedAccountLinks: [
        { title: 'My Profile',href: `${process.env.VUE_APP_FREELANCER_HOME_PATH}/`},
        { title: 'My Orders', href: `${process.env.VUE_APP_FREELANCER_HOME_PATH}/`},
        { title: 'Register to Sell', href: process.env.VUE_APP_REGISTER_AS_SUPPLIER },
        { title: 'Become a Sourcing Expert', href: `${process.env.VUE_APP_SERVER_BASE_URL}/become-a-sourcingexpert` }
      ],
    }
  },
  computed: {
    ...mapGetters(['isUserLoggedIn', 'getUserAuthInfo']),
    linksForAccountList() {
      return this.isUserLoggedIn ? this.loggedAccountLinks : this.accountLinks
    },
    loggedAccountLinks() {
      return this.getUserAuthInfo.role === 'freelancer' ? this.freelancerLoggedAccountLinks : this.buyerLoggedAccountLinks
    },
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.src="https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "7876633",
          formId: "718b1906-6189-44c9-93a1-a17a2571a336",
          target: "#hubspotForm",
          region: "na1",
        })
      }
    })
  }
}
</script>